import React from 'react'

type Props = {
  style?: React.CSSProperties
  children: React.ReactNode
  className?: string
  ref?: React.RefObject<HTMLDivElement>
}

export default ({ children, className, ref, style }: Props) => {
  return (
    <div style={{ ...style }} ref={ref} className={`container ${className || ''}`}>
      {children}
    </div>
  )
}
